import styled, { css } from 'styled-components';

export default styled.div<{ hover?: boolean }>`
  display: grid;
  border-bottom: 1px solid ${props => props.theme.palette.divider};
  padding: ${props => props.theme.spacing(1)}px;

  ${props =>
    props.hover &&
    css`
      transition: ${props =>
        props.theme.transitions.create('background', {
          duration: props.theme.transitions.duration.shortest
        })};

      &:hover {
        background: ${props => props.theme.palette.action.hover};
      }
    `}
`;
